import React, { useEffect, useState } from "react";
import Select from "react-select";
import { apiService } from "../../service/ApiService";
import { Form } from "react-bootstrap";

import { useTranslation } from "react-i18next";

const IntegrationSelect = ({ title, defaultValue = null, handler }) => {
  const {
    t,
  } = useTranslation();

  title = title === undefined ? t("common.labels.platform") : title;
  const [integrations, setIntegrations] = useState([]);
  const [selectedIntegration, setSelectedIntegration] = useState(null);

  const handleChange = (e) => {
    setSelectedIntegration(e);
    if (e) handler(e.value);
    else handler(null);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const getIntegrations = async () => {
    try {
      const response = await apiService.get(`api/v1/integrations`);
      const availableIntegrations = response.data.map((el) => {
        return {
          value: el.id,
          label: el.name,
        };
      });
      setIntegrations(availableIntegrations);
      setNewValue(null);
    } catch (error) {
      console.error(error);
    }
  };

  const setNewValue = () => {
    const selectedIntegration = integrations.find((el) => el.value === defaultValue);
    if (selectedIntegration) setSelectedIntegration(selectedIntegration);
  };

  useEffect(() => {
    getIntegrations();
  }, []);

  useEffect(() => {
    setNewValue();
  }, [defaultValue]);

  return (
    <>
      <Form.Group>
        <Select
          styles={customStyles}
          isClearable={true}
          className="primary"
          name="integrationSelect"
          onChange={handleChange}
          value={selectedIntegration}
          options={integrations}
          noOptionsMessage={() => t("messages.noPlatformsAreAvailable")}
          placeholder={`${title}`}
        />
      </Form.Group>
    </>
  );
};

export default IntegrationSelect;
